import { render, staticRenderFns } from "./Detail-Template.vue?vue&type=template&id=06e02e00&scoped=true"
import script from "./Detail-Template.vue?vue&type=script&lang=js"
export * from "./Detail-Template.vue?vue&type=script&lang=js"
import style0 from "./Detail-Template.vue?vue&type=style&index=0&id=06e02e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e02e00",
  null
  
)

export default component.exports